import React from 'react';
import wedding1 from "../../images/Images Webp/wedding_partners.webp"
const SabounDay = () => {
    return (
        <div>
            <div>
                <h2 className="text-pink-600 text-3xl font-extrabold mb-6 text-center">Saboun (Jour 1)</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                    Que les festivités commencent avec la vivante cérémonie du &quot;Saboun&quot; ! Imaginez une
                    scène animée remplie de rires et de bavardages entre membres de la famille et amies
                    féminines. Ensemble, ils créent un trésor appelé le trousseau, symbolisant le voyage
                    excitant de la mariée dans la vie conjugale.
                </p>
                <h2 className="text-pink-600 text-3xl font-extrabold mb-6 text-center">Hazzén el Farch (Jour 2)</h2>
                <img src={wedding1} alt="2" className="w-full h-auto mb-8 rounded-lg shadow-md" />
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                    L&apos;excitation bourdonne dans l&apos;air alors que le trousseau de la mariée prend le devant de 
                    la scène. Fièrement présenté à toute la famille, le trousseau devient le point focal des 
                    activités de la journée. Avec l&apos;aide de tous, l&apos;espace se transforme en une vitrine 
                    captivante de la future maison de la mariée - une vision de chaleur et d&apos;amour.
                </p>
                <h2 className="text-pink-600 text-3xl font-extrabold mb-6 text-center">Hammam (Jour 3)</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                    Ah, une journée d&apos;indulgence et de tranquillité vous attend ! Imaginez la mariée, 
                    entourée de ses compagnes les plus proches, alors qu&apos;elles se lancent dans une 
                    expérience traditionnelle du &quot;Hammam&quot;. Imaginez des employés qualifiés la dorlotant 
                    avec des gommages luxueux, des masques nourrissants et des traitements capillaires 
                    décadents. C&apos;est un moment pour se détendre, se relaxer et se prélasser en prévision 
                    des festivités joyeuses à venir.
                </p>
                <h2 className="text-pink-600 text-3xl font-extrabold mb-6 text-center">Cérémonie du Henné (Jour 4)</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                    Plongez dans un univers de beauté intemporelle et d&apos;art raffiné lors de la &quot;Journée du 
                    Henné&quot;. Parée de splendides teintes de rouge, la mariée accueille avec impatience 
                    l&apos;expert du &quot;henaya&quot;. Avec des mains expertes et un soin méticuleux, des motifs de 
                    henné époustouflants prennent vie sur ses mains et ses pieds, chaque coup de pinceau 
                    symbolisant des bénédictions et de la bonne fortune pour son voyage à venir.
                </p>
                <h2 className="text-pink-600 text-3xl font-extrabold mb-6 text-center">Harkous (Jour 5)</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                    Les festivités se poursuivent avec l&apos;application d&apos;une deuxième couche de henné, 
                    chaque tourbillon et chaque arabesque ajoutant au charme radieux de la mariée. Et 
                    n&apos;oublions pas le rituel unique d&apos;épilation au sucre - un témoignage de l&apos;engagement de 
                    la mariée à être au mieux de sa forme pour le jour du mariage !
                </p>
                <h2 className="text-pink-600 text-3xl font-extrabold mb-6 text-center">Cérémonies Gatari et Hidjeb</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                    À l&apos;approche du grand jour, les coutumes régionales prennent le devant de la scène avec
                    les cérémonies Gatari et Hidjeb. Imaginez des scènes de joie et d&apos;excitation alors que la 
                    famille du marié se rend à la maison de la mariée, apportant des cadeaux et des vœux 
                    de bonheur. Dans les régions nord-ouest, la cérémonie Hidjeb marque l&apos;annonce 
                    formelle de l&apos;engagement du couple, accompagnée d&apos;échanges émouvants de bagues 
                    et de bénédictions.
                </p>
                <p className="text-gray-700 text-lg leading-relaxed">
                    Ces cinq premiers jours témoignent du pouvoir des liens familiaux et communautaires, 
                    chaque instant étant rempli d&apos;amour, de rires et de traditions chères. Restez à l&apos;écoute 
                    pour notre prochain volet, où nous plongerons dans l&apos;énergie exaltante du jour du 
                    mariage lui-même - une célébration comme aucune autre !
                </p>
            </div>
        </div>
    );
}

export default SabounDay;
